import { ConfirmDialog } from '@gogame/components';
import { useMutation } from '@gogame/query';
import { useScreenModalV2 } from '@gogame/screens';

import { deleteTagsCategory } from 'scenes/GalleryTags/sources/galleryTags';

import { remove } from '../queryKeyFactory';

export const useDeleteCategory = () => {
  const showModal = useScreenModalV2(ConfirmDialog);

  const deleteMutation = useMutation(remove(), deleteTagsCategory, {
    successMessage: () => `Gallery Tag deleted`,
    errorMessage: (e) => e.message,
  });

  const handleAction = async (category) => {
    await showModal({
      title: `Delete Tag Category?`,
      bodyText: `«${category.name}»`,
      confirmActionLabel: 'Delete',
    });
    await deleteMutation.mutateAsync({ id: category.id });
  };

  return [handleAction, deleteMutation];
};
